import { Link, Tooltip } from '@mui/material';
import React from 'react';
import { closeDialogAction, openDialogAction } from 'store/actions/dialogsActions';
import moment from 'moment';
import { useSelector } from 'store/hooks';
import { useAppState } from 'store/Provider';
import Dashboard from 'types/entities/Dashboard';
import Customer from 'types/entities/Customer';
import { useHistory } from 'react-router-dom';
import { loadCustomerAction, loadRolesAction } from 'store/actions/appActions';
import { changeTabAction, loadDeliverablesAction } from 'store/actions/deliverableActions';
import { changeReportTabAction } from 'store/actions/deliverableSheetActions';
import { DeliverableReportTab } from 'types/enums/DeliverableReportTab';
import { DeliverableTabPage } from 'types/enums/DeliverableTabPage';
import { selectFilterAction } from 'store/actions/filterActions';

const ActionsCell = React.memo((row: Dashboard) => {
  const { dispatch } = useAppState();
  const { app } = useSelector((state) => state);
  const history = useHistory();

  const actionCallFn = () => {
    if (row.action_name === 'Create Order') {
      dispatch(
        openDialogAction({
          name: 'todoCreateOrder',
          data: row,
        })
      );
    } else {
      // missing validation and missing Acceptance
      const customer = app.customers.find((item) => item.name === row?.client_name) as Customer;

      const slug = customer?.slug;

      const previous_customer: string | null = localStorage.getItem('active_customer');
      if (customer && previous_customer) {
        if (JSON.parse(previous_customer)?.id !== customer?.id) {
          localStorage.setItem('active_customer', JSON.stringify(customer));
          // Dispatch actions
          dispatch(loadCustomerAction(customer));
          dispatch(loadRolesAction());
          localStorage.setItem('navigation_screen', JSON.stringify('customer'));
        }

        localStorage.setItem('from_source_page', 'dashboard');
        setTimeout(() => {
          history.push(`/${slug}/deliverables/${row.order_id}`);
          if (row.action_name === 'Accept Now' || row.action_name === 'Submit Now') {
            const filterKey = 'mission_advancement_id';
            dispatch(changeTabAction(DeliverableTabPage.PRODUCTION));
            if (row.action_name === 'Accept Now') {
              dispatch(
                selectFilterAction({
                  [filterKey]: ['NOT_ACCEPTED'],
                })
              );
            } else {
              const today = moment().format('YYYY-MM-DD');
              const new_expected_date = moment(row.new_expected_date).format('YYYY-MM-DD');
              localStorage.setItem('forecast_date_mode', 'range');
              localStorage.setItem('forecast_date_view', 'date');

              dispatch(
                selectFilterAction({
                  forecast_date_start: new_expected_date ? [new_expected_date] : [],
                  forecast_date_end: today ? [today] : [],
                  [filterKey]: ['NOT_SUBMITTED'],
                })
              );
            }
          } else if (row.action_name === 'Validate Now') {
            dispatch(changeTabAction(DeliverableTabPage.TODO));
          } else {
            dispatch(changeTabAction(DeliverableTabPage.REPORTS));
            if (row?.deliverable_type === 'technical') {
              dispatch(changeReportTabAction(DeliverableReportTab.TECHNICAL));
            } else {
              dispatch(changeReportTabAction(DeliverableReportTab.FINANCIAL));
            }
          }
          dispatch(
            loadDeliverablesAction({
              deliverables: null,
              totalItems: 0,
              totalPages: 0,
            })
          );
        }, 800);
      }
    }
  };
  return (
    <Link variant="body2" onClick={() => actionCallFn()} noWrap underline="always" component="button">
      {row.action_name ?? ''}
    </Link>
  );
});

export default ActionsCell;
